import React from 'react';

const Footer = () => {
  return (
    <div className="text-center text-gray-400 py-2 bg-green-100 border-t-2 border-green-200 border-solid">
      Deparment of Security and Defense - All hail King Shan! 👑
    </div>
  );
};

export default Footer;
